import { DATA_MODIFIED, DATA_REMOVED, ADD_LISTENER } from '../types';
import * as merge from 'deepmerge'
import _ from 'lodash';

import { combineReducers } from 'redux';

let dataReducer = (state = {}, action) => {
  switch(action.type) {
    case DATA_MODIFIED :
      return merge(state, action.payload);

    case DATA_REMOVED :
      let newState = _.cloneDeep(state);
      delete action.payload.path.split('.').reduce((obj, key) => obj[key], newState)[action.payload.id];
      return newState;

    default:
      return state;
  }
}

let listenerReducer = (state = {}, action) => {
  switch(action.type) {
    case ADD_LISTENER :
      return {...state, [action.payload.ref]: action.payload.listener};
    default:
      return state;
  }
}

const combined = combineReducers({
  data: dataReducer,
  listeners: listenerReducer
})

export default combined;
